import { render, staticRenderFns } from "./quemSomosEditar.vue?vue&type=template&id=09f42bcb&scoped=true&"
import script from "./quemSomosEditar.vue?vue&type=script&lang=js&"
export * from "./quemSomosEditar.vue?vue&type=script&lang=js&"
import style0 from "./quemSomosEditar.vue?vue&type=style&index=0&id=09f42bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f42bcb",
  null
  
)

export default component.exports